export var isDarkTheme = function(appearance) {
    return appearance === "dark";
};
